import { useTranslation } from "react-i18next";

import { Badge, BadgeColors } from "@dotnet/telematics-design-system";

import { DesktopLicenseStatusIconProps } from "./types";

const DesktopLicenseStatusIcon = ({
    isEnabled
}: DesktopLicenseStatusIconProps) => {
    const { t } = useTranslation();

    return (
        <Badge
            color={isEnabled ? BadgeColors.success : BadgeColors.warning}
            inverted
        >
            {t(`Table##license ${isEnabled ? "enabled" : "disabled"}`)}
        </Badge>
    );
};

export default DesktopLicenseStatusIcon;
